import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LandingPageDetail, GallerySummary, ImageAsset, cloneLandingPage } from '../../models/cms-models';
import { LandingPageMetadataFormComponent } from '../landing-page-metadata-form/landing-page-metadata-form';
import { PublicationSettingsComponent } from '../publication-settings/publication-settings';
import { LandingPageBlocksEditorComponent } from '../landing-page-blocks-editor/landing-page-blocks-editor';

@Component({
  selector: 'cms-landing-page-editor',
  imports: [
    CommonModule,
    LandingPageMetadataFormComponent,
    PublicationSettingsComponent,
    LandingPageBlocksEditorComponent,
  ],
  templateUrl: './landing-page-editor.html',
  styleUrl: './landing-page-editor.css',
})
export class LandingPageEditorComponent {
  private _landingPage: LandingPageDetail | null = null;

  @Input() saving = false;
  @Input() canDelete = true;
  @Input() tagSuggestions: string[] = [];
  @Input() availableImages: ImageAsset[] = [];
  @Input() availableGalleries: GallerySummary[] = [];
  @Output() deleteRequested = new EventEmitter<string>();

  draft: LandingPageDetail | null = null;
  metadataExpanded = false;
  publishingExpanded = false;
  structureExpanded = false;

  @Input()
  set landingPage(value: LandingPageDetail | null) {
    const previousLandingPageId = this._landingPage?.id ?? null;
    this._landingPage = value;
    this.draft = value ? cloneLandingPage(value) : null;

    if (value && value.id !== previousLandingPageId) {
      this.metadataExpanded = false;
      this.publishingExpanded = false;
      this.structureExpanded = false;
    }
  }

  get landingPage(): LandingPageDetail | null {
    return this._landingPage;
  }

  get hasUnsavedChanges(): boolean {
    if (!this.draft || !this._landingPage) {
      return false;
    }

    return this.serializeLandingPage(this.draft) !== this.serializeLandingPage(this._landingPage);
  }

  updateDraft(landingPage: LandingPageDetail): void {
    this.draft = landingPage;
  }

  updateBlocks(blocks: LandingPageDetail['blocks']): void {
    if (!this.draft) {
      return;
    }

    this.draft = {
      ...this.draft,
      blocks,
    };
  }

  toggleSection(section: 'metadata' | 'publishing' | 'structure'): void {
    if (section === 'metadata') {
      this.metadataExpanded = !this.metadataExpanded;
      return;
    }

    if (section === 'publishing') {
      this.publishingExpanded = !this.publishingExpanded;
      return;
    }

    this.structureExpanded = !this.structureExpanded;
  }

  private serializeLandingPage(landingPage: LandingPageDetail): string {
    return JSON.stringify(landingPage);
  }
}
